import axios from "axios";
import { useContext, useEffect } from "react";
import { ViewerContext } from "../../Context/ViewerContext/ViewerContextProvider";
import { XktContext } from "../../Context/XktContext/XktContextProvider";

import {
    setGroupViewCache,
    setGroupviewObjects,
    setGroupviewRender,
} from "../../Context/ViewerContext/Reducer";

import { GroupviewCacheItem, GroupviewModel } from "../../Models/Groupview";
import { getConfig } from "../../_Configuration/configuration";

import TreeviewRenderer, { TreeRenderElement } from "./TreeviewRenderer";

const Groupview = () => {
    const { state } = useContext(XktContext);
    const { state: viewerState, dispatch } = useContext(ViewerContext);

    const loadModels = async () => {
        const objs: GroupviewModel[][] = [];
        const newCache: GroupviewCacheItem[] = viewerState.groupViewCache;
        let cacheUpdated = false;
        const cdn = getConfig().cdn;
        for (const src of state.models) {
            const treeCache =
                src?.groupViewPath ??
                `${src?.url ?? cdn}/${src.folder}/groupview.json`;
            const cacheItem = viewerState.groupViewCache.filter(
                (x) => x.src === treeCache
            );
            if (cacheItem.length === 0) {
                const modelResp = await axios.get(treeCache);
                let model = modelResp.data as GroupviewModel[];
                if (modelResp.data.constructor != "".constructor) {
                    model = model.map((x) => {
                        x.src = treeCache;
                        x.modelName = src.modelId;
                        return x;
                    });
                    //if file not found vite returns a html file as string instead of a json
                    objs.push(model);

                    newCache.push({
                        src: treeCache,
                        model,
                        modelId: src.modelId,
                    });
                    cacheUpdated = true;
                }
            } else {
                objs.push(cacheItem[0].model);
            }
        }
        if (cacheUpdated) {
            dispatch(setGroupViewCache(newCache));
        }
        dispatch(setGroupviewObjects(objs));
    };

    const convertToRenderModel = (
        models: GroupviewModel[][]
    ): TreeRenderElement[] => {
        const renderModels: TreeRenderElement[] = [];
        for (const model of models) {
            for (const ifcGroup of model) {
                const obj: TreeRenderElement = {
                    id: ifcGroup.IfcClass, 
                    type: ifcGroup.IfcClass,
                    name: ifcGroup.IfcClass,
                    depth: 0,
                    isExpanded: false,
                    children: [],
                };
                renderModels.push(obj);
                for (const type of ifcGroup.Types) {
                    const typeObj: TreeRenderElement = {
                        id: `${ifcGroup.modelName}#${ifcGroup.IfcClass}#${type.Name ?? "Anonymous Type"}`,
                        type: type.Name ?? "Anonymous Type",
                        name:(type.Name!= null && type.Name !=="")? type.Name : `Anonymous Type (${ifcGroup.modelName})`,
                        depth: 1,
                        children: [],
                        parent: obj.id,
                        isExpanded: false,
                    };
                    obj.children?.push(typeObj);
                    for (const object of type.Objects) {
                        const objectObj: TreeRenderElement = {
                            id: `${ifcGroup.modelName}#${object.id}`,
                            type: object.type ?? "Anonymous Object",
                            name:(object.name!= null && object.name !=="")? object.name : "Anonymous Object",
                            children: [],
                            parent: typeObj.id,
                            depth: 2,
                            isExpanded: false,
                        };
                        typeObj.children?.push(objectObj);
                    }
                }
            }
        }

        const retValue: TreeRenderElement[] = [];
        for (const renderModel of renderModels) {
            const existingModel = retValue.filter(
                (x) => x.name == renderModel.name
            );
            if (existingModel.length > 0) {
                existingModel[0].children = [ ...existingModel[0].children ?? [], ...renderModel.children ?? []];
            } else {
                retValue.push(renderModel);
            }
        }
        return retValue;
    };
    useEffect(() => {
        loadModels();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.models]);

    useEffect(() => {
        dispatch(
            setGroupviewRender(
                convertToRenderModel(viewerState.groupViewObjects,)
            )
        );
    }, [viewerState.groupViewObjects]);

    return (
        <>
            <TreeviewRenderer
                data={viewerState.groupViewRender}
                setData={(data) => {
                    dispatch(setGroupviewRender(data));
                }}
            />
        </>
    );
};

export default Groupview;
